import { memo, useCallback, useState } from 'react';
import { Button, SelectChangeEvent, Stack } from '@mui/material';
import { useAppDispatch } from 'store';
import DialogContent from 'components/dialog/DialogContent';
import DialogTitle from 'components/dialog/DialogTitle';
import DialogBody from 'components/dialog/DialogBody';
import DialogButtons from 'components/dialog/DialogButtons';
import { closeDialog } from 'store/dialog/dialogSlice';
import { putProjectStateSave } from 'store/project/projectSlice';
import { closeBackdrop, openBackdrop } from 'store/backdrop/backdropSlice';
import { useProject } from 'hooks/useProject';
import DialogSelect from 'components/dialog/DialogSelect';
import { showMessage } from 'store/message/messageSlice';

interface IProjectStateDialogProps {
  projectId: string;
  projectState: string;
}
type stateKey = 'PD' | 'PR' | 'CP';

function ProjectStateDialog({ projectId, projectState }: IProjectStateDialogProps): JSX.Element {
  const dispatch = useAppDispatch();
  const { getProjectIdDetail } = useProject();
  const { mutate } = getProjectIdDetail(projectId || '');
  const projectStateKey: stateKey[] = ['PD', 'PR', 'CP'];
  const [_projectState, setProjectState] = useState<stateKey>(
    projectStateKey.find(_obj => _obj === projectState || '') as stateKey,
  );
  const handleSelectStatus = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setProjectState(value as stateKey);
  };

  const handleClick = () => {
    dispatch(openBackdrop({}));
    dispatch(putProjectStateSave({ projectId, projectState: _projectState }))
      .unwrap()
      .then(response => {
        const { status } = response;
        if (status === 200) {
          dispatch(showMessage({ message: response?.data?.message || '성공했습니다.', variant: 'success' }));
          mutate();
        }
      })
      .catch(e => console.log(e))
      .finally(() => {
        dispatch(closeBackdrop());
        dispatch(closeDialog());
      });
  };
  const handleDisplay = useCallback((_value: stateKey) => {
    if (_value === 'PD') return 'pending';
    if (_value === 'PR') return 'proceeding';
    if (_value === 'CP') return 'complete';
    return '-';
  }, []);

  return (
    <DialogContent width={{ desktop: 450, mobile: '100vw' }} height={{ desktop: 'fit-content', mobile: 'fit-content' }}>
      <DialogTitle>프로젝트 상태 수정</DialogTitle>
      <DialogBody style={{ overflowX: 'hidden', overflowY: 'hidden !important' }}>
        <DialogSelect
          label="프로젝트 상태"
          labelWidth={90}
          select={_projectState}
          selectList={projectStateKey.map(obj => ({ display: handleDisplay(obj), value: obj }))}
          onChange={handleSelectStatus as (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void}
        />
      </DialogBody>
      <DialogButtons>
        <Stack direction="row" spacing={3.75}>
          <Button onClick={handleClick} variant="contained" sx={{ width: 100 }}>
            수정
          </Button>
        </Stack>
      </DialogButtons>
    </DialogContent>
  );
}

export default memo(ProjectStateDialog);
